import actions from '../../actionTypes';

export default (status) => {
  return {
    type: actions.RESEND_VERIFY_COMPLETED,
    status
  };
};


// WEBPACK FOOTER //
// ./src/reducers/auth/actions/resendVerifyCompleted.js